import { Component, DestroyRef, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { UntypedFormGroup, ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatInput } from '@angular/material/input';

import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
    selector: 'app-identity-document-input',
    templateUrl: './identity-document-input.component.html',
    styleUrls: ['./identity-document-input.component.scss'],
    imports: [ReactiveFormsModule, MatFormField, MatLabel, TranslateModule, MatSelect, MatOption, MatInput]
})
export class IdentityDocumentInputComponent implements OnInit {

  private destroyRef = inject(DestroyRef);
  identityDocumentGroup: UntypedFormGroup;

  constructor(private changeDetectorRef: ChangeDetectorRef, private controlContainer: ControlContainer) {
  }

  ngOnInit() {
    this.identityDocumentGroup = <UntypedFormGroup>this.controlContainer.control;

    this.identityDocumentGroup.get('type').valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((type) => {
      if (type == null) {
        this.identityDocumentGroup.get('number').disable();
      } else {
        this.identityDocumentGroup.get('number').enable();
      }
      this.changeDetectorRef.detectChanges();
    });
  }
}
